import { usePageTitle } from 'hooks/pageTitle.js'

export default function Home() {
  usePageTitle()

  return <div></div>
}
